module.exports = __webpack_public_path__ + "files/6f092821c7f9fbbbfe9a0b63dd87e991.png";